export const ACTIVIST_TAB = 'activistTab';
export const NON_ACTIVIST_TAB = 'nonActivistTab';
